<template>
  <article class="employee-settlement__wrap">
    <div class="employee-settlement__prin">
      <md-button
        class="md-dense md-raised md-primary boleta__button-print"
        @click="print"
      >
        <img :src="require('@/assets/img/printer.svg')" class="icon-button" />
        Imprimir Boleta
      </md-button>
    </div>
    <section class="employee-settlement" v-if="!!ldata">
      <div class="employee-settlement__confirm" v-if="!ldata.confirmGetDown">
        <md-button
          class="md-dense md-raised md-accent boleta__button-print"
          @click="bajaConfirm"
        >
          <img :src="require('@/assets/img/check.svg')" class="icon-button" />
          Confirmar Baja
        </md-button>
      </div>
      <section class="employee-settlement__header">
        <div class="employee-settlement__business-info" v-if="currentBusiness">
          <p>
            <strong>{{ currentBusiness.name }}</strong>
          </p>
          <p>RUC: {{ currentBusiness.ruc }}</p>
          <p>{{ currentBusiness.address }}</p>
        </div>
        <div class="employee-settlement__title">
          <h2>LIQUIDACIÓN DE BENEFICIOS SOCIALES</h2>
        </div>
      </section>
      <section class="employee-settlement__section employee-settlement__general-info">
        <div
          class="employee-settlement__inner-scetion employee-settlement__personal-info"
        >
          <div class="info-row">
            <p class="label">Nombres y Apellidos</p>
            :
            <p class="value">{{ ldata.fullName }}</p>
          </div>
          <div class="info-row">
            <p class="label">Cargo</p>
            :
            <p class="value">{{ ldata.professionalPosition }}</p>
          </div>
          <div class="info-row">
            <p class="label">{{ ldata.documentType }}</p>
            :
            <p class="value">{{ ldata.documentNumber }}</p>
          </div>
          <div class="info-row">
            <p class="label">Motivo de Cese</p>
            :
            <p class="value" v-if="employeeDownData">
              {{ reasons[employeeDownData.reason] }}
            </p>
            <p class="value" v-else>{{ reasons[ldata.getdownDetail] }}</p>
          </div>
          <div class="info-row">
            <p class="label">Fecha de ingreso</p>
            :
            <p class="value">{{ ldata.admittedAt | formatDate }}</p>
          </div>
          <div class="info-row">
            <p class="label">Fecha de cese</p>
            :
            <p class="value">{{ ldata.getdownAt | formatDate }}</p>
          </div>
          <div class="info-row">
            <p class="label">Tiempo de Servicios</p>
            :
            <p class="value">{{ ldata.timeOfServices }}</p>
          </div>
        </div>
        <div class="employee-settlement__inner-scetion employee-settlement__concepts">
          <h3>BASE PARA EL CÁLCULO DE LA L.B.S.</h3>
          <table class="table-liquidation">
            <tr>
              <th>Conceptos</th>
              <th></th>
              <th>SUELDO</th>
              <th>C.T.S</th>
              <th>Vacaciones</th>
              <th>Gratificaciones</th>
              <th></th>
            </tr>
            <tr>
              <td>Sueldo Básico</td>
              <td></td>
              <td>{{ ldata.grossSalary | currency }}</td>
              <td>
                {{ ((ldata.grossSalary * ldata.lastCtsType) / riaConst) | currency }}
              </td>
              <td>{{ ldata.grossSalary | currency }}</td>
              <td>
                {{
                  ldata.isRIA
                    ? (ldata.grossSalary * ldata.lastGratificationType) / 6
                    : (ldata.grossSalary * ldata.lastGratificationType) | currency
                }}
              </td>
              <td></td>
            </tr>
            <tr v-if="ldata.lastFamilyAssignment > 0">
              <td>Asig. Familiar</td>
              <td></td>
              <td>{{ ldata.lastFamilyAssignment | currency }}</td>
              <td>{{ ldata.lastFamilyAssignment | currency }}</td>
              <td>{{ ldata.lastFamilyAssignment | currency }}</td>
              <td>{{ ldata.lastFamilyAssignment | currency }}</td>
              <td></td>
            </tr>
            <tr>
              <td>1/6 Gratificación</td>
              <td></td>
              <td></td>
              <td>
                {{ ((ldata.periodGratCts * ldata.lastCtsType) / riaConst) | currency }}
              </td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td>Promedio de Comisiones / Bonos / Horas Extra</td>
              <td></td>
              <td></td>
              <td>{{ ctsVariants | currency }}</td>
              <td>{{ ldata.promCommisionsVac | currency }}</td>
              <td>
                {{
                  ldata.promCommisionsGrat + ldata.gratificationProjection.prom3in6extraHours + ldata.gratificationProjection.prom3in6bonuses
                    ? (ldata.promCommisionsGrat + ldata.gratificationProjection.prom3in6extraHours + ldata.gratificationProjection.prom3in6bonuses) * ldata.lastGratificationType
                    : 0 | currency
                }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td></td>
              <td>Total</td>
              <td class="table-liquidation__cell--value">
                {{ resultSalary | currency }}
              </td>
              <td class="table-liquidation__cell--value">
                {{ ldata.truncCtsBase | currency }}
              </td>
              <td class="table-liquidation__cell--value">
                {{ ldata.vacationBase | currency }}
              </td>
              <td class="table-liquidation__cell--value">
                {{ ldata.truncGratBase | currency }}
              </td>
              <td></td>
            </tr>
          </table>
        </div>
      </section>
      <section class="employee-settlement__section employee-settlement__concept-detail">
        <table class="table-total table-total--remunerations">
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th>Mensual</th>
            <th></th>
            <th>Diario</th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <td>1)</td>
            <td class="left">SUELDO</td>
            <td></td>
            <td></td>
            <td>{{ ldata.grossSalary | decimales }}</td>
            <td></td>
            <td>{{ ldata.salaryByDay | decimales }}</td>
            <td></td>
            <td>S/</td>
          </tr>
          <tr class="row-data">
            <td></td>
            <td class="left">Sueldo {{ monthLabel }}</td>
            <td>Días</td>
            <td>:</td>
            <td>{{ ldata.lastWorkedDays }}</td>
            <td>x</td>
            <td>{{ ldata.salaryByDay | decimales }}</td>
            <td></td>
            <td class="right">{{ workedDaysResult | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.vacationMonth > 0">
            <td></td>
            <td class="left">Vacaciones tomadas {{ monthLabel }}</td>
            <td>Días</td>
            <td>:</td>
            <td>{{ ldata.vacationMonth }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">{{ ldata.vacationSalaryMonth | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.lastFamilyAssignment">
            <td></td>
            <td class="left">Asignacion Familiar {{ monthLabel }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">{{ ldata.lastFamilyAssignment | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.monthCommissions > 0">
            <td></td>
            <td class="left">Comisiones {{ monthLabel }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">{{ ldata.monthCommissions | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.monthBonuses > 0">
            <td></td>
            <td class="left">Bonos {{ monthLabel }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">{{ ldata.monthBonuses | decimales }}</td>
          </tr>
          <tr class="row-total">
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="right">Total 1</th>
            <th class="right">
              {{
                (workedDaysResult +
                  ldata.monthCommissions +
                  ldata.monthBonuses +
                  ldata.lastFamilyAssignment + ldata.vacationSalaryMonth)
                  | decimales
              }}
            </th>
          </tr>
        </table>
      </section>
      <section
        class="employee-settlement__section employee-settlement__concept-detail"
        v-if="gratiTruncTotalResult > 0"
      >
        <table class="table-total table-total--remunerations">
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th v-if="ldata.isRIA"></th>
            <th v-else>Anual</th>
            <th></th>
            <th>Mensual</th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <td>{{ itemIndex["grati"] }})</td>
            <td class="left">GRATIFICACIONES</td>
            <td></td>
            <td></td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>{{ ldata.truncGratBase | decimales }}</td>
            <td></td>
            <td>
              {{
                ldata.isRIA ? ldata.truncGratBase : ldata.truncGratMonthprice | decimales
              }}
            </td>
            <td></td>
            <td>S/</td>
          </tr>
          <tr class="row-data">
            <td></td>
            <td class="left">Gratificaciones Truncas</td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>Meses</td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>:</td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>{{ ldata.truncGratMonths }}</td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>x</td>
            <td>
              {{ ldata.isRIA ? ldata.gratiMonth : ldata.truncGratMonthprice | decimales }}
            </td>
            <td></td>
            <td class="right">{{ gratiTruncMonthResult | decimales }}</td>
          </tr>
          <tr class="row-data">
            <td></td>
            <td class="left"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>Bonificación {{ ldata.rateGratifications }}%</td>
            <td class="right">{{ gratiTruncBonus | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.devengGratMonths > 0">
            <td></td>
            <td class="left">Gratificaciones Devengadas</td>
            <td>Meses</td>
            <td>:</td>
            <td>{{ ldata.devengGratMonths }}</td>
            <td>x</td>
            <td>{{ ldata.truncGratMonthprice | decimales }}</td>
            <td></td>
            <td class="right">{{ devengGratBase | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.devengGratMonths > 0">
            <td></td>
            <td class="left"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>Bonificación {{ ldata.rateGratifications }}%</td>
            <td class="right">{{ devengGratBonus | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.absenceInGratPeriod > 0">
            <td></td>
            <td class="left">Inasistencias injustificadas</td>
            <td>Días</td>
            <td>:</td>
            <td>{{ ldata.absenceInGratPeriod }}</td>
            <td>x</td>
            <td>{{ ldata.truncGratDayprice | decimales }}</td>
            <td></td>
            <td class="right">{{ totalAbsenceGrat | decimales }}</td>
          </tr>
          <tr class="row-total">
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="right">Total {{ itemIndex["grati"] }}</th>
            <th class="right">
              {{ gratiTruncTotalResult | decimales }}
            </th>
          </tr>
        </table>
      </section>
      <section
        class="employee-settlement__section employee-settlement__concept-detail"
        v-if="ctsTruncResult > 0"
      >
        <table class="table-total table-total--remunerations">
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th v-if="ldata.isRIA"></th>
            <th v-else>Anual</th>
            <th></th>
            <th>Mensual</th>
            <th v-if="ldata.isRIA"></th>
            <th v-else>Diario</th>
            <th></th>
          </tr>
          <tr>
            <td>{{ itemIndex["cts"] }})</td>
            <td class="left">CTS TRUNCAS</td>
            <td></td>
            <td></td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>{{ ldata.truncCtsBase | decimales }}</td>
            <td></td>
            <td v-if="ldata.isRIA">{{ ldata.ctsMonth | decimales }}</td>
            <td v-else>{{ (ldata.truncCtsBase / 12) | decimales }}</td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>{{ (ldata.truncCtsBase / 360) | decimales }}</td>
            <td>S/</td>
          </tr>
          <tr class="row-data" v-if="ldata.truncCtsMonths > 0">
            <td></td>
            <td class="left" v-if="ldata.isRIA">{{ actualMonthRIA }}</td>
            <td class="left" v-else>({{ getCTSPeriod() }})</td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>Meses</td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>:</td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>{{ ldata.truncCtsMonths }}</td>
            <td v-if="ldata.isRIA"></td>
            <td v-else>x</td>
            <td v-if="ldata.isRIA">{{ ldata.ctsMonth | decimales }}</td>
            <td v-else>{{ (ldata.truncCtsBase / 12) | decimales }}</td>
            <td></td>
            <td v-if="ldata.isRIA">{{ ldata.ctsMonth | decimales }}</td>
            <td v-else class="right">{{ ctsTruncMonthsResult | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.truncCtsDays > 0">
            <td></td>
            <td class="left"></td>
            <td>Días</td>
            <td>:</td>
            <td>{{ ldata.truncCtsDays }}</td>
            <td>x</td>
            <td>{{ (ldata.truncCtsBase / 360) | decimales }}</td>
            <td></td>
            <td class="right">{{ ctsTruncDaysResult | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.absenceInCtsPeriod > 0">
            <td></td>
            <td class="left">Inasistencias injustificadas</td>
            <td>Días</td>
            <td>:</td>
            <td>{{ ldata.absenceInCtsPeriod }}</td>
            <td>x</td>
            <td>{{ ldata.ctsDay | decimales }}</td>
            <td></td>
            <td class="right">{{ totalAbsenceCts | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.devengCts > 0">
            <td></td>
            <td class="left">CTS DEVENGADAS</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">{{ ldata.devengCts | decimales }}</td>
          </tr>
          <tr class="row-total">
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="right">Total {{ itemIndex["cts"] }}</th>
            <th class="right">
              {{ ctsTruncResult | decimales }}
            </th>
          </tr>
        </table>
      </section>
      <section
        class="employee-settlement__section employee-settlement__concept-detail"
        v-if="vacationResult > 0"
      >
        <table class="table-total table-total--remunerations">
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th>Anual</th>
            <th></th>
            <th>Diario</th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <td>{{ itemIndex["vaca"] }})</td>
            <td class="left">VACACIONES</td>
            <td></td>
            <td></td>
            <td>{{ ldata.vacationBase | decimales }}</td>
            <td></td>
            <td>{{ (ldata.vacationBase / 30) | decimales }}</td>
            <td></td>
            <td>S/</td>
          </tr>
          <tr class="row-data" v-if="ldata.devengVacationsDays > 0">
            <td></td>
            <td class="left">Devengadas</td>
            <td>Días</td>
            <td>:</td>
            <td>{{ ldata.devengVacationsDays | decimales }}</td>
            <td>x</td>
            <td>{{ (ldata.vacationBase / 30) | decimales }}</td>
            <td></td>
            <td class="right">{{ devengVacationResult | decimales }}</td>
          </tr>
          <tr class="row-data" v-if="ldata.truncVacationsDays > 0">
            <td></td>
            <td class="left">Truncas</td>
            <td>Días</td>
            <td>:</td>
            <td>{{ ldata.truncVacationsDays | decimales }}</td>
            <td>x</td>
            <td>{{ (ldata.vacationBase / 30) | decimales }}</td>
            <td></td>
            <td class="right">{{ truncVacationResult | decimales }}</td>
          </tr>

          <tr class="row-total">
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="right">Total {{ itemIndex["vaca"] }}</th>
            <th class="right">{{ vacationResult | decimales }}</th>
          </tr>
        </table>
      </section>
      <section
        class="employee-settlement__section employee-settlement__concept-detail"
        id="lbs-section-otros"
        v-if="totalDevoluciones > 0"
      >
        <table class="table-total table-total--remunerations">
          <!-- <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th>Anual</th>
            <th colspan="2">Diario</th>
            <th></th>
            <th></th>
          </tr> -->
          <tr>
            <th>{{ itemIndex["devo"] }})</th>
            <th class="left">OTROS INGRESOS</th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th>S/</th>
          </tr>
          <tr class="row-data" v-if="ldata.lastResume5ta">
            <td></td>
            <td class="left">Devolución de 5ta Categoría</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">{{ ldata.lastResume5ta.devolution | decimales }}</td>
          </tr>
          <tr
            class="row-data"
            v-for="concept in ldata.devolutionConcepts"
            :key="`dev-concp-${concept.id}`"
          >
            <td></td>
            <td class="left">{{ concept.description }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">{{ concept.value | decimales }}</td>
          </tr>
          <tr class="row-total">
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="right">Total {{ itemIndex["devo"] }}</th>
            <th class="right">{{ totalDevoluciones | decimales }}</th>
          </tr>
        </table>
      </section>
      <section class="employee-settlement__section employee-settlement__concept-detail">
        <table class="table-total table-total--remunerations">
          <tr class="row-total">
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="right">Total Remuneración</th>
            <th class="right notop">
              {{
                (workedDaysResult +
                  ldata.monthCommissions +
                  ldata.monthBonuses +
                  ldata.lastFamilyAssignment + ldata.vacationSalaryMonth +
                  gratiTruncTotalResult +
                  ctsTruncResult +
                  vacationResult +
                  totalDevoluciones)
                  | decimales
              }}
            </th>
          </tr>
        </table>
      </section>
      <section class="employee-settlement__section employee-settlement__concept-detail">
        <table class="table-total table-total--deductions">
          <tr>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th colspan="2"></th>
            <th></th>
            <th></th>
          </tr>
          <tr>
            <td>{{ itemIndex["desc"] }})</td>
            <td class="left">DESCUENTOS</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>S/</td>
          </tr>
          <tr class="row-data">
            <td></td>
            <td class="left">{{ ldata.pensionSystemLabel }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right"></td>
          </tr>
          <tr class="row-data" v-if="ldata.pensionCalc.mandatoryContribution > 0">
            <td></td>
            <td class="left">Aporte Obligatorio</td>
            <td>{{ (ldata.mandatoryContributionPercentage * 100) | decimales }}%</td>
            <td>{{ ldata.pensionCalc.mandatoryContribution | decimales }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right"></td>
          </tr>
          <tr class="row-data" v-if="ldata.pensionCalc.secure > 0">
            <td></td>
            <td class="left">Seguro</td>
            <td>{{ (ldata.securePrimePercentage * 100) | decimales }}%</td>
            <td>{{ ldata.pensionCalc.secure | decimales }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right"></td>
          </tr>
          <tr class="row-data" v-if="ldata.pensionCalc.commission > 0">
            <td></td>
            <td class="left">Comisión</td>
            <td>{{ (ldata.commisionPercentage * 100) | decimales }}%</td>
            <td>{{ ldata.pensionCalc.commission | decimales }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right"></td>
          </tr>
          <tr class="row-data" v-if="ldata.pensionCalc.onp > 0">
            <td></td>
            <td class="left">ONP</td>
            <td>{{ (ldata.commisionPercentage * 100) | decimales }}%</td>
            <td>{{ ldata.pensionCalc.onp | decimales }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right"></td>
          </tr>
          <tr class="row-data">
            <td></td>
            <td class="left"></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">
              -{{
                (ldata.pensionCalc.commission +
                  ldata.pensionCalc.secure +
                  ldata.pensionCalc.mandatoryContribution +
                  ldata.pensionCalc.onp)
                  | decimales
              }}
            </td>
          </tr>
          <tr
            class="row-data"
            v-for="concept in deductionConcepts"
            :key="`dev-concp-${concept.id}`"
          >
            <td></td>
            <td class="left">{{ concept.description }}</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">-{{ concept.value | decimales }}</td>
          </tr>
          <tr
            class="row-data"
            v-if="quintaLiquidacion"
          >
            <td></td>
            <td class="left">IMPUESTO A LA RENTA 5TA</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="right">-{{ quintaLiquidacion | decimales }}</td>
          </tr>
          <tr class="row-total">
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="right">Total {{ itemIndex["desc"] }}</th>
            <th class="right">-{{ totalDescuentos | decimales }}</th>
          </tr>
        </table>
      </section>
      <section class="employee-settlement__section employee-settlement__concept-detail">
        <table class="table-total table-total--remunerations">
          <tr class="row-total">
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th></th>
            <th class="right">Total a Pagar</th>
            <th class="right notop">
              {{
                (workedDaysResult +
                  ldata.lastFamilyAssignment +
                  ldata.monthCommissions +
                  ldata.monthBonuses  + ldata.vacationSalaryMonth +
                  gratiTruncTotalResult +
                  ctsTruncResult +
                  totalDevoluciones +
                  vacationResult -
                  totalDescuentos)
                  | decimales
              }}
            </th>
          </tr>
        </table>
      </section>
      <section class="employee-settlement__section employee-settlement__concept-detail">
        <table class="table-aportes">
          <tr>
            <th colspan="3">Aporte del Empleador</th>
          </tr>
          <tr class="border-top">
            <td>{{ healthRegime }}</td>
            <td class="right" v-if="healthRegime=='SIS'"></td>
            <td class="right" v-else>{{ ldata.rateGratifications }}%</td>
            <td class="right">
              {{ ldata.esSalud | currency }}
            </td>
          </tr>
          <tr class="border-top" v-if="ldata.eps > 0">
            <td>EPS</td>
            <td class="right">{{ 9 - ldata.rateGratifications }}%</td>
            <td class="right">
              {{ ldata.eps | currency }}
            </td>
          </tr>
          <tr class="border-top" v-if="ldata.sctr > 0">
            <td>SCTR</td>
            <td class="right">1.23%</td>
            <td class="right">
              {{
                ((workedDaysResult +
                  ldata.monthCommissions +
                  ldata.lastFamilyAssignment +
                  ldata.monthBonuses +
                  vacationResult) *
                  (1.23 / 100))
                  | currency
              }}
            </td>
          </tr>
        </table>
      </section>
      <section class="employee-settlement__section employee-settlement__concept-detail">
        <h3>CONFORMIDAD</h3>
        <p>
          Al recibir la presente liquidacion, yo
          {{ ldata.fullName }} identificado con {{ ldata.documentType }}
          {{ ldata.documentNumber }}, dejo constancia que no tengo que hacer ningún
          reclamo a la empresa {{ currentBusiness.name }} y en señal de conformidad firmo
          la presente.
        </p>
        <div class="firmas-wrap">
          <div class="firma">
            <div class="firma__espacio"></div>
            <div class="firma__texto">Empleador</div>
          </div>
          <div class="firma">
            <div class="firma__espacio"></div>
            <div class="firma__texto">Trabajador</div>
          </div>
        </div>
      </section>
    </section>
  </article>
</template>

<script>
import numeral from 'numeral';
const healthRegimeMap = {
  "00": "EsSalud",
  "01": "EsSalud",
  "05": "EsSalud",
  "20": "Sanidad FFAA y Policiales",
  "21": "SIS",
}
export default {
  name: "employee-settlement",
  data() {
    return {
      ldata: null,
      month: new Date().getMonth(),
      year: new Date().getFullYear(),
      monthsLabel: [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Setiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ],
      employeeDownData: {},
      reasons: {
        "01": "Renuncia",
        "03": "Despido",
        "05": "Jubilación",
        "06": "Invalidez permanente",
        "07": "Fin de contrato",
        "08": "Mutuo disenso",
        "09": "Fallecimiento",
      },
      indexList: 0,
      tregister: null
    };
  },
  computed: {
    currentBusiness() {
      return this.$store.state.business.currentBusiness;
    },
    resultSalary() {
      if (!this.ldata) return 0;
      return this.ldata.grossSalary + this.ldata.lastFamilyAssignment;
    },
    ctsTruncMonthsResult() {
      if (!this.ldata) return 0;
      return (this.ldata.truncCtsMonths * this.ldata.truncCtsBase) / 12;
    },
    ctsTruncDaysResult() {
      if (!this.ldata) return 0;
      return this.ldata.truncCtsDays * numeral(numeral((this.ldata.truncCtsBase / 360)).format("0,0.00")).value();
    },
    ctsTruncResult() {
      if (!this.ldata) return 0;
      return this.ldata.isRIA
        ? this.ldata.ctsMonth
        : this.ctsTruncMonthsResult +
            this.ctsTruncDaysResult +
            this.totalAbsenceCts +
            this.ldata.devengCts;
    },
    gratiTruncMonthResult() {
      if (!this.ldata) return 0;
      return this.ldata.isRIA
        ? this.ldata.gratiMonth
        : this.ldata.truncGratMonths * this.ldata.truncGratMonthprice;
    },
    gratiTruncBonus() {
      return this.ldata.isRIA
        ? (this.ldata.gratiMonth * this.ldata.rateGratifications) / 100
        : (this.gratiTruncMonthResult * this.ldata.rateGratifications) / 100;
    },
    devengGratBase(){
      return this.ldata.truncGratMonthprice * this.ldata.devengGratMonths
    },
    devengGratBonus(){
      return this.devengGratBase * this.ldata.rateGratifications/100
    },
    gratiDevengResult() {
      if (!this.ldata) return 0;
      return this.devengGratBase + this.devengGratBonus;
    },
    gratiTruncTotalResult() {
      return this.gratiTruncMonthResult + this.gratiTruncBonus + this.gratiDevengResult + this.totalAbsenceGrat;
    },
    truncVacationResult() {
      if (!this.ldata) return 0;
      if (this.ldata.truncVacationsDays < 0) return 0;
      return (this.ldata.truncVacationsDays * this.ldata.vacationBase) / 30;
    },
    devengVacationResult() {
      if (!this.ldata) return 0;
      return (this.ldata.devengVacationsDays * this.ldata.vacationBase) / 30;
    },
    vacationResult() {
      return this.truncVacationResult + this.devengVacationResult;
    },
    workedDaysResult() {
      if (!this.ldata) return 0;
      return this.ldata.salaryByDay * this.ldata.lastWorkedDays;
    },
    monthLabel() {
      return this.monthsLabel[this.month];
    },
    afpCommision() {
      if (!this.ldata) return 0;
      return (
        (this.workedDaysResult +
          this.ldata.monthCommissions +
          this.ldata.monthBonuses +
          this.vacationResult +
          this.ldata.lastFamilyAssignment) *
        this.ldata.commisionPercentage
      );
    },
    afpSecure() {
      if (!this.ldata) return 0;
      return (
        (this.workedDaysResult +
          this.ldata.monthCommissions +
          this.ldata.monthBonuses +
          this.vacationResult +
          this.ldata.lastFamilyAssignment >
        this.ldata.maxSecureRemuneration
          ? this.ldata.maxSecureRemuneration
          : this.workedDaysResult +
            this.ldata.monthCommissions +
            this.ldata.monthBonuses +
            this.vacationResult +
            this.ldata.lastFamilyAssignment) * this.ldata.securePrimePercentage
      );
    },
    afpMandatory() {
      if (!this.ldata) return 0;
      return (
        (this.workedDaysResult +
          this.ldata.monthCommissions +
          this.ldata.monthBonuses +
          this.vacationResult +
          this.ldata.lastFamilyAssignment) *
        this.ldata.mandatoryContributionPercentage
      );
    },

    summatoryDevolutionConcepts() {
      if (!this.ldata) return 0;
      return this.ldata.devolutionConcepts.reduce(
        (acc, item) => (acc = acc + item.value),
        0
      );
    },
    totalDevoluciones() {
      if (!this.ldata) return 0;
      return this.ldata.lastResume5ta.devolution + this.summatoryDevolutionConcepts;
    },
    deductionConcepts(){
      if(!this.ldata) return [];
      return this.ldata.deductionConcepts.map(concept => {
        if(concept.conceptCode === '0705'){
          concept.value = concept.value - this.ldata.absenceMonth*this.ldata.salaryByDay
        }
        return concept
      })
    },
    summatoryDeductionConcepts() {
      if (!this.ldata) return 0;
      return this.deductionConcepts.reduce(
        (acc, item) => (acc = acc + item.value),
        0
      );
    },
    totalDescuentos() {
      if (!this.ldata) return 0;
      return (
        this.ldata.pensionCalc.commission +
        this.ldata.pensionCalc.secure +
        this.ldata.pensionCalc.mandatoryContribution +
        this.ldata.pensionCalc.onp +
        this.summatoryDeductionConcepts + 
        this.quintaLiquidacion
      );
    },
    riaConst() {
      if (this.ldata.isRIA) return 12;
      return 1;
    },
    actualMonthRIA() {
      return `${this.monthsLabel[new Date(this.ldata.getdownAt).getMonth()]} ${new Date(
        this.ldata.getdownAt
      ).getFullYear()}`;
    },
    totalAbsenceGrat() {
      return this.ldata.absenceInGratPeriod * this.ldata.truncGratDayprice * -1;
    },
    totalAbsenceCts() {
      return this.ldata.absenceInCtsPeriod * this.ldata.ctsDay * -1;
    },
    itemIndex() {
      let indexes = {
        grati: 2,
        cts: 3,
        vaca: 4,
        devo: 5,
        desc: 6,
      };
      if (this.gratiTruncTotalResult == 0) {
        indexes["cts"] = indexes["cts"] - 1;
        indexes["vaca"] = indexes["vaca"] - 1;
        indexes["devo"] = indexes["devo"] - 1;
        indexes["desc"] = indexes["desc"] - 1;
      }
      if (this.ctsTruncResult == 0) {
        indexes["vaca"] = indexes["vaca"] - 1;
        indexes["devo"] = indexes["devo"] - 1;
        indexes["desc"] = indexes["desc"] - 1;
      }
      if (this.vacationResult == 0) {
        indexes["devo"] = indexes["devo"] - 1;
        indexes["desc"] = indexes["desc"] - 1;
      }
      if (this.totalDevoluciones == 0) {
        indexes["desc"] = indexes["desc"] - 1;
      }
      return indexes;
    },
    ctsVariants() {
      return (this.ldata.resumeCts.promBonuses3in6 + this.ldata.resumeCts.promCommisions + this.ldata.resumeCts.promExtraHours3in6)*this.ldata.lastCtsType
    },
    healthRegime(){
      if(!this.tregister) return ""
      return healthRegimeMap[this.tregister.healthRegime]
    },
    quintaLiquidacion(){
      return this.ldata.lastResume5ta.newMonth5ta
    }
  },
  async beforeCreate() {
    await this.$store.dispatch("getBusinessById", this.$store.state.business.businessId);
  },
  async created() {
    this.employeeDownData = JSON.parse(window.localStorage.getItem("employeeBaja"));
    // console.log(this.employeeDownData.dateEnd)
    let dateAux = new Date(this.$route.query.dateEnd);
    console.log(dateAux);
    dateAux.setHours(23, 59, 59);
    console.log(dateAux);
    let { data, status } = await this.$store.dispatch("getDownData", {
      id: this.$route.params.id,
      date: new Date(dateAux).toISOString(),
    });
    if (status === 200) {
      this.ldata = data;
      this.month = new Date(this.ldata.getdownAt).getMonth();
      const tregister = await this.$store.dispatch("getTRegister", this.employeeDownData.tregisterId)
      console.log({tregister});
      this.tregister = tregister.data
    }

  },
  methods: {
    print() {
      window.print();
    },
    bajaConfirm() {
      if (!this.ldata.confirmGetDown) {
        this.$store
          .dispatch("downTR", {
            id: this.$route.params.id,
            body: {
              date: new Date(this.$route.query.dateEnd).toISOString(),
              detail: this.employeeDownData.reason,
            },
          })
          .then((r) => {
            if (r.status == 200) {
              this.$toasted.success("Empleado dado de baja", {
                theme: "bubble",
                position: "top-left",
                duration: 1000,
                className: "short-message",
              });
            }
          });
      }
    },
    getCTSPeriod() {
      const month = new Date(this.ldata.getdownAt).getMonth();
      let year = new Date(this.ldata.getdownAt).getFullYear();
      let firstMonth, lastMonth, firstYear, lastYear;
      if ([10, 11, 0, 1, 2, 3].includes(month)) {
        firstMonth = 10;
        lastMonth = 3;
      }
      if ([4, 5, 6, 7, 8, 9].includes(month)) {
        firstMonth = 4;
        lastMonth = 9;
      }
      if ([10, 11].includes(month)) {
        firstYear = year;
        lastYear = year + 1;
      }
      if ([0, 1, 2, 3].includes(month)) {
        firstYear = year - 1;
        lastYear = year;
      }
      if ([4, 5, 6, 7, 8, 9].includes(month)) {
        firstYear = lastYear = year;
      }

      return `Periodo ${this.monthsLabel[firstMonth]} ${firstYear} - ${this.monthsLabel[lastMonth]} ${lastYear}`;
    },
  },
};
</script>

<style lang="scss">
@media print {
  .employee-settlement__wrap {
    background-color: #ffffff !important;
    padding: 1rem !important;
  }
  .employee-settlement__section {
    table {
      tr {
        td, th {
          margin-right: 0.5em;
        }
      }
    }
  }
  .table-total {
    table-layout: unset;
  }
  /* #lbs-section-otros {
    page-break-before: always;
  } */
}
</style>
<style lang="scss" scoped>
// th,
// td {
//   border: thin solid red;
// }
.employee-settlement__wrap {
  background-color: #eceff8;
  padding: 2rem 3rem;
  position: relative;
}
.employee-settlement {
  padding: 1rem;
  background-color: #ffffff;
  position: relative;
  section {
    margin: 1rem 0;
    width: 100%;
  }
  &__section {
    border: thin solid currentColor;
    padding: 1rem;
  }
  &__inner-section {
    margin: 1rem 0;
  }
  &__title {
    text-align: center;
    margin: 1rem 0;
  }
  &__personal-info {
    margin: 1rem 0;
    .info-row {
      display: flex;
      justify-content: flex-start;
      margin: 0.5em 0;
      .label {
        width: 150px;
      }
    }
  }
}
.table-liquidation {
  width: 100%;
  border-collapse: separate;
  border-spacing: 10px 0;
  tr {
    & th:first-child,
    & td:first-child {
      text-align: left;
    }
    th,
    td {
      min-width: 100px;
      padding: 0.1em 0;
    }
    th {
      text-align: center;
    }
    td {
      text-align: right;
    }
    &:last-child {
      td {
        padding: 0.5em 0;
        font-weight: bold;
      }
      .table-liquidation__cell--value {
        border-top: thin solid currentColor;
      }
    }
  }
}
.table-total {
  width: 100%;
  // table-layout: fixed;
  th,
  td {
    text-align: center;
    &:first-child {
      width: 25px;
    }
    &:nth-child(2) {
      width: 300px;
    }
    &:last-child {
      width: 100px !important;
    }
  }
  td {
    max-width: 275px;
  }

  &--remunerations {
    th,
    td {
      text-align: center;
      &:first-child {
        width: 25px;
      }
      &:nth-child(2) {
        width: 300px;
      }
      &:nth-child(4) {
        width: 25px;
      }
      &:nth-child(6) {
        width: 25px;
      }
      &:nth-child(8) {
        width: 150px;
      }
    }
    td {
      text-align: center;
      &:first-child {
        width: 25px;
      }
      &:nth-child(2) {
        width: 300px;
      }
      // &:nth-child(4) {
      //   width: 25px !important;
      // }
      // &:nth-child(6) {
      //   width: 25px !important;
      // }
    }
  }
  tr:not(.row-data) {
    td {
      font-weight: bold;
    }
  }

  .left {
    text-align: left;
  }
  .right {
    text-align: right;
  }
  .row-total {
    th {
      border-top: thin solid transparent;
    }
    th:nth-child(8) {
      width: 150px;
    }
    th:last-child {
      border-top: thin solid #000;
    }
    th.notop {
      border: none;
    }
  }
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}
.table-aportes {
  width: 350px;
  border: thin solid #000000;
  column-gap: 0;
  .border-top td {
    border-top: thin solid #000000;
  }
  th {
    text-align: left;
    // border: thin solid #000000;
  }
}
.firmas-wrap {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  .firma {
    width: 200px;
    margin: 1rem 5rem;
    &__espacio {
      height: 150px;
    }
    &__texto {
      text-align: center;
      font-weight: bold;
      border-top: thin solid #000000;
    }
  }
}
.icon-button {
  height: 1.5rem;
  width: auto;
  margin: 0 0.5rem;
}
.employee-settlement__confirm {
  position: fixed;
  right: 2.5%;
  top: 10%;
  z-index: 100;
}
</style>
